export const PIE_COLORS = ['#f76863', '#1FCC67'];

export default {
  chart: {
    type: 'pie',
    backgroundColor: 'transparent',
    width: 240,
    height: 220,
    spacing: [0, 0, 0, 0],
    margin: [0, 0, 0, 0],
  },
  title: { text: '' },
  credits: { enabled: false },
  legend: { enabled: false, events: { itemClick: () => false } },
  colors: PIE_COLORS,
  tooltip: {
    backgroundColor: '#3b4355',
    borderRadius: 8,
    padding: 8,
    borderWidth: 0,
    style: { color: '#fff', fontSize: '14px' },
    useHTML: true,
    formatter() {
      return `${this.point.key}: $${this.point.value}`;
    },
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      borderWidth: 0,
      startAngle: 0,
      dataLabels: { enabled: false },
      showInLegend: false,
      size: 175,
      states: { hover: { halo: { size: 8 } } },
    },
  },
};
